module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.image) { 
    ; __append(" <img src=\"")
    ; __append(escapeFn( locals.image ))
    ; __append("\" alt=\"Logo\" class=\"img-fluid mx-auto\"> ")
    ;  } else { 
    ; __append(" <img src=\"/assets/images/icons/no-image.svg\" alt=\"Logo\" class=\"img-fluid mx-auto\"> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/brand/image_preview/template.ejs
// module id = 1301
// module chunks = 1